import React from 'react';
import { homeworkColors } from '../constants';
import sprite from '../../../img/sprites.svg';
import './schedule-legend.scss';

const TYPES = [
  { key: 'lesson', label: 'Заняття' },
  { key: 'trial', label: 'Пробне' },
  { key: 'catch_up', label: 'Відпрацювання' },
];

const HOMEWORK = [
  { color: 1, label: 'ДЗ не відкривали' },
  { color: 2, label: 'ДЗ розпочато' },
  { color: 3, label: 'ДЗ прострочено' },
  { color: 4, label: 'ДЗ виконано' },
];

const ScheduleLegend = () => (
  <div className="schedule-legend">
    {TYPES.map(({ key, label }) => (
      <span className="schedule-legend__item" key={key}>
        <i className={`schedule-legend__box schedule-legend__box--${key}`} />
        {label}
      </span>
    ))}

    {HOMEWORK.map(({ color, label }) => (
      <span className="schedule-legend__item" key={color}>
        <svg className={`icon icon--sm icon--${homeworkColors[color]}`}>
          <use href={`${sprite}#book`}></use>
        </svg>
        {label}
      </span>
    ))}
  </div>
);

export default ScheduleLegend;
